import React from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

import OmDropdownField from '../forms/OmDropdownField';

import {
    getFormReferences,
    getSelectedForm,
} from '@om/redux/selectors/investmentCalculator/investmentCalculator';

import EmergencyFundCalculator from './EmergencyFundCalculator';
import GenerateRegularIncomeCalculator from './GenerateRegularIncomeCalculator';
import BuildWealthCalculator from './BuildWealthCalculator';
import ShortTermGoalCalculator from './ShortTermGoalCalculator';
import LongTermGoalCalculator from './LongTermGoalCalculator';

import {
    reInitialize,
    setSelectedForm,
} from '@om/redux/actions/investmentCalculator/investmentCalculator';

import { OmInvestmentCalcContainer } from '@om/component-library-react';

import './investment-calculator.scss';

const InvestmentCalculator = ({
    twoColumnImageLeftContent,
    twoColumnImageRightContent,
    tableContent,
    slot,
}) => {
    let dispatch = useDispatch();
    const { formReferences, selectedForm } = useSelector(
        createStructuredSelector({
            formReferences: getFormReferences,
            selectedForm: getSelectedForm,
        }),
    );

    const switchForm = e => {
        dispatch(setSelectedForm(e.detail.value));
        // refresh investment calculator shared state; removes previous calc results if any
        dispatch(reInitialize());
    };

    return (
        <OmInvestmentCalcContainer slot={slot}>
            <div slot='drop-down'>
                <h6 className='no-bottom-margin'>
                    What do you want to save for?
                </h6>
                <OmDropdownField
                    useNativeMobileDropdown={true}
                    className='inline-field'
                    required='true'
                    size='small'
                    label='What do you want to save for?'
                    form-id='investment-calculator'
                    placeholder='Emergency Fund'
                    name='formOption'
                    align='left'
                    onSelectHandler={event => switchForm(event)}
                    reduxValue={selectedForm}
                    options={formReferences?.map(option => ({
                        value: option.name,
                        label: option.description,
                    }))}
                />
            </div>
            <div className='investment-form' slot='investment-form'>
                {selectedForm === 'emergency' && (
                    <EmergencyFundCalculator
                        twoColumnImageLeftContent={twoColumnImageLeftContent}
                    />
                )}
                {selectedForm === 'regularIncome' && (
                    <GenerateRegularIncomeCalculator
                        twoColumnImageRightContent={twoColumnImageRightContent}
                        twoColumnImageLeftContent={twoColumnImageLeftContent}
                    />
                )}
                {selectedForm === 'shortTerm' && (
                    <ShortTermGoalCalculator
                        twoColumnImageRightContent={twoColumnImageRightContent}
                        twoColumnImageLeftContent={twoColumnImageLeftContent}
                    />
                )}
                {selectedForm === 'longTerm' && (
                    <LongTermGoalCalculator
                        twoColumnImageRightContent={twoColumnImageRightContent}
                        twoColumnImageLeftContent={twoColumnImageLeftContent}
                    />
                )}
                {selectedForm === 'buildWealth' && (
                    <BuildWealthCalculator
                        twoColumnImageRightContent={twoColumnImageRightContent}
                        twoColumnImageLeftContent={twoColumnImageLeftContent}
                    />
                )}
            </div>
        </OmInvestmentCalcContainer>
    );
};

export default InvestmentCalculator;
